import styled from 'styled-components';
import { scrollBar } from '../../../../../style/helpers';

export const SidebarScrollBlockStyled = styled.div`
  height: calc(100% - 180px);
  ${scrollBar}
`;
